import { jsx as _jsx } from "react/jsx-runtime";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Alert, Snackbar, Slide } from '@mui/material';
import React, { useEffect } from 'react';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import styles from './styles';
export const SnackBarMessage = () => {
    const { globalState: { displaySnackBar, snackBarType = 'success', snackBarMsg }, hideSnackBar, } = useGlobalStateContext();
    useEffect(() => {
        let timer;
        if (displaySnackBar) {
            timer = setTimeout(() => handleClose(), 3000);
        }
        return () => {
            clearTimeout(timer);
        };
    });
    const handleClose = () => {
        hideSnackBar();
    };
    return (_jsx(Snackbar, { sx: { mt: 2 }, anchorOrigin: { vertical: 'top', horizontal: 'center' }, open: displaySnackBar, TransitionComponent: (props) => _jsx(Slide, { ...props, direction: 'down' }), ContentProps: {
            style: {
                opacity: 1,
                transform: 'none',
            },
        }, TransitionProps: {
            appear: false,
        }, children: _jsx(Alert, { severity: snackBarType, sx: styles[snackBarType], iconMapping: {
                success: _jsx(CheckCircleOutlineIcon, { fontSize: 'inherit' }),
            }, children: snackBarMsg }) }, snackBarMsg));
};
